import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import th from './locales/th.json';
import km from './locales/km.json';
import ms from './locales/ms.json';
import lo from './locales/lo.json';

// th is a FULL locale (whole app). km/ms/lo are marketing-page locales ({pricing, land} only) — every
// other key falls back to English via fallbackLng, so the owner dashboard stays usable in English for
// now while the public landing/pricing speak the local language.
const LANG_KEY = 'cometqr_lang';            // localStorage key for the chosen UI language
const saved = (() => { try { return localStorage.getItem(LANG_KEY); } catch (e) { return null; } })();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    th: { translation: th },
    km: { translation: km },
    ms: { translation: ms },
    lo: { translation: lo },
  },
  lng: saved || 'en',
  fallbackLng: 'en',
  returnEmptyString: false,
  interpolation: { escapeValue: false }, // React already escapes
});

export const LANG_STORAGE_KEY = LANG_KEY;
export default i18n;
